export default __webpack_public_path__ + "static/IN-5907HD_Lense-Adjustment-7d06484bdcdaf1acb543872be776e3b1.png";